module.exports = __webpack_public_path__ + "img/x-black.957be0a4.svg";